import Field from '@/components/ui/forms/Field';
import FormGroup from '@/components/ui/forms/FormGroup';
import Input from '@/components/ui/forms/Input';
import Label from '@/components/ui/forms/Label';

interface Props {
  label: string;
  value?: string;
}

const AbsencesFormStaticInput: React.FC<Props> = ({ label, value }) => (
  <FormGroup>
    <Label>{label}</Label>
    <Field>
      <Input isStatic value={value} disabled />
    </Field>
  </FormGroup>
);

export default AbsencesFormStaticInput;
